import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appPickerButton]'
})
export class PickerButtonDirective<T> {

  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @HostBinding('style.cursor')
  cursor = 'pointer';


  @HostListener('click') onClick(event) {
    this.clicked.emit(event);
  }

  constructor(public elementRef: ElementRef) {
  }
}
